import _ from 'lodash';
import React from 'react';
import { Alert } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { InconsistenciesResponseType } from '.';
import { OverlayLoader } from '../shared/component';
import validationRuleGroupMap from './validation-rule-group-map';
import { ValidationProcess, ValidationRuleType } from './types';

const showRule = (rule: ValidationRuleType, filterGroup: string, entityId?: number): boolean => {
  const isGroupApplicable = filterGroup === rule.validationRuleGroup;
  if (!isGroupApplicable) return false;

  const filterAlertFunction = _.get(validationRuleGroupMap[rule.validationRuleGroup], 'filterAlert');
  if (filterAlertFunction) return filterAlertFunction(rule, entityId);

  return true;
};

type Props = {
  filterGroup: string;
  filterDisplayZone?: string;
  entityId?: number;
};

export const InconsistenciesAlert: React.FC<React.PropsWithChildren<Props>> = ({ filterGroup, filterDisplayZone, entityId }) => {
  const validationRules = useSelector((state: any): InconsistenciesResponseType => state.validationRules ?? {});

  const submissionRules = validationRules.values[ValidationProcess.SUBMISSION] || [];
  const approvalRules = validationRules.values[ValidationProcess.APPROVAL] || [];

  const validationRulesFiltered = _.filter(
    [...submissionRules, ...approvalRules],
    (rule: ValidationRuleType) =>
      (filterDisplayZone ? rule.validationRuleDisplayZone === filterDisplayZone : true) && showRule(rule, filterGroup, entityId)
  );

  const validationRuleFilteredError = _.filter(
    [...validationRulesFiltered],
    (rule: ValidationRuleType) => rule.validationRuleLevel === 'ERROR'
  );

  const validationRuleFilteredWarning = _.filter(
    [...validationRulesFiltered],
    (rule: ValidationRuleType) => rule.validationRuleLevel === 'WARNING'
  );

  return (
    <>
      {validationRuleFilteredError && validationRuleFilteredError.length > 0 && (
        <Alert style={{ padding: '5px 10px' }} variant="danger">
          {validationRules.isLoading && <OverlayLoader />}
          <ul className="mb-0">
            {_.map(validationRuleFilteredError, (rule: ValidationRuleType, i: number) => (
              <li key={i}>{rule.message}</li>
            ))}
          </ul>
        </Alert>
      )}
      {validationRuleFilteredWarning && validationRuleFilteredWarning.length > 0 && (
        <Alert style={{ padding: '5px 10px' }} variant="warning">
          {validationRules.isLoading && <OverlayLoader />}
          <ul className="mb-0">
            {_.map(validationRuleFilteredWarning, (rule: ValidationRuleType, i: number) => (
              <li key={i}>{rule.message}</li>
            ))}
          </ul>
        </Alert>
      )}
    </>
  );
};
